import { useLazyQuery } from '@apollo/client/react';
import { useAtom, useSetAtom } from 'jotai';
import { useCallback } from 'react';

import { GetSamePatientDocument } from '~/graphql/generated/graphql';
import { patientDetailDialogState } from '~/state/partials/patient_detail_dialog/atoms';
import { TabType } from '~/state/partials/patient_detail_dialog/types';
import { samePatientModalState } from '~/state/patient/atoms';

export const useSamePatient = (guestPatientId: string) => {
  const setSamePatientModalState = useSetAtom(samePatientModalState);
  const [{ isOpen }, setPatientDetailDialogState] = useAtom(patientDetailDialogState);

  const [getPatient, { called, loading }] = useLazyQuery(GetSamePatientDocument);

  const getSamePatientByGuestPatient = useCallback(async () => {
    if (guestPatientId && !isOpen) {
      try {
        const res = await getPatient({
          variables: {
            guestPatientId,
          },
        });
        const patient =
          res.data?.node?.__typename === 'WebVisitor' ||
          res.data?.node?.__typename === 'DirectVisitor'
            ? res.data.node.samePatient
            : undefined;
        if (patient && patient.appointments.nodesCount > 0) {
          setSamePatientModalState((_state) => ({
            ..._state,
            isOpen: true,
            patientId: patient.id,
            guestPatientId: guestPatientId,
          }));
        } else {
          setPatientDetailDialogState((_state) => ({
            ..._state,
            isOpen: true,
            type: 'message' as TabType,
            patientId: guestPatientId,
          }));
        }
      } catch {
        // 何もしない
      }
    }
  }, [getPatient, guestPatientId, isOpen, setPatientDetailDialogState, setSamePatientModalState]);

  return {
    getSamePatientByGuestPatient,
    loading: !called || loading,
  };
};
